import { render, staticRenderFns } from "./FollowupDueWarning.vue?vue&type=template&id=2aebc3ab&scoped=true"
import script from "./FollowupDueWarning.vue?vue&type=script&lang=js"
export * from "./FollowupDueWarning.vue?vue&type=script&lang=js"
import style0 from "./FollowupDueWarning.vue?vue&type=style&index=0&id=2aebc3ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebc3ab",
  null
  
)

export default component.exports